import {
  Users,
  ClipboardList,
  Settings,
  Mail,
  UserPlus, 
  Phone, 
  Server,
  Shield,
  TrendingUp,
  Ban,
  DollarSign,
  BarChart3
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export interface MenuItem {
  path: string;
  icon: LucideIcon;
  labelKey: string;
  requiredRole?: string;
  category: 'adblock' | 'ssp' | 'noconsent' | 'admin';
}

export const menuItems: MenuItem[] = [
  { 
    path: '/app/overview', 
    icon: BarChart3, 
    labelKey: 'sidebar.overview',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/adblock-bypass', 
    icon: Shield, 
    labelKey: 'sidebar.adblock.bypass',
    category: 'adblock'
  },
  { 
    path: '/app/ssp-dashboard', 
    icon: TrendingUp, 
    labelKey: 'sidebar.sspDashboard',
    category: 'ssp'
  },
  { 
    path: '/app/no-consent-dashboard', 
    icon: Ban, 
    labelKey: 'sidebar.noConsentDashboard',
    category: 'noconsent'
  },
  { 
    path: '/app/users', 
    icon: Users, 
    labelKey: 'sidebar.userManagement',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/prospects', 
    icon: UserPlus, 
    labelKey: 'sidebar.prospects',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/contacts', 
    icon: Phone, 
    labelKey: 'sidebar.contacts',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/tasks', 
    icon: ClipboardList, 
    labelKey: 'sidebar.tasks',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/domain-services', 
    icon: Server, 
    labelKey: 'sidebar.domainServices',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/productivity-hub', 
    icon: Mail, 
    labelKey: 'sidebar.productivityHub',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  { 
    path: '/app/admin-settings', 
    icon: Settings, 
    labelKey: 'sidebar.settings',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
  {
    path: '/app/exchange-rates',
    icon: DollarSign,
    labelKey: 'sidebar.exchangeRates',
    requiredRole: 'ADMIN',
    category: 'admin'
  },
];

// Helper function to get menu items grouped by category
export const getMenuItemsByCategory = () => {
  const categories = menuItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {} as Record<string, MenuItem[]>);
  
  return categories;
};
